import { render, staticRenderFns } from "./AnatomistHeaderText.vue?vue&type=template&id=4fe4d419&scoped=true&"
import script from "./AnatomistHeaderText.vue?vue&type=script&lang=js&"
export * from "./AnatomistHeaderText.vue?vue&type=script&lang=js&"
import style0 from "./AnatomistHeaderText.vue?vue&type=style&index=0&id=4fe4d419&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe4d419",
  null
  
)

export default component.exports